import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Spinner, Tab, Tabs } from "react-bootstrap";
import logoAC from "../../assets/Logo Assesment Center-06.png";
import logoGMP from "../../assets/grahamultibintang.jpg";

const WelcomePage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { id, id2 } = useParams();
  const [isMobile, setIsMobile] = useState(false);
  const [activeTab, setActiveTab] = useState("informasi");
  const [searchTerm, setSearchTerm] = useState("");
  const [dataPosition, setDataPosition] = useState([]);
  const [dataCompany, setDataCompany] = useState([]);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_URL}ac/recruitment/participant/company_detail/${id2}`,
        {
          headers: {
            Authorization:
              "Basic " +
              btoa(
                `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`
              ),
          },
        }
      )
      .then((res) => {
        setDataCompany(res.data);
        setLoading(false);
      });
    axios
      .get(
        `${process.env.REACT_APP_URL}ac/recruitment/participant/position/detail/${id}`,
        {
          headers: {
            Authorization:
              "Basic " +
              btoa(
                `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`
              ),
          },
        }
      )
      .then((res) => {
        setDataPosition(res.data.data);
        setLoading(false);
      });
  }, []);
  const faqs = [
    {
      question: "Apa itu Officer Development Program (ODP)?",
      answer:
        "ODP adalah program pengembangan karyawan yang dirancang khusus untuk mencetak pemimpin masa depan. Peserta akan menjalani pelatihan intensif, rotasi kerja di berbagai divisi, dan mendapatkan mentoring langsung.",
    },
    {
      question: "Bagaimana cara mendaftar ODP 2025 ini?",
      answer:
        'Pendaftaran hanya dilakukan secara online melalui halaman: https://odp-recruitment.onegml.com/15/16',
    },
    {
      question: "Kapan periode pendaftaran dibuka dan ditutup?",
      answer:
        "Pendaftaran dibuka mulai 23 Mei 2025 dan ditutup pada 1 Juni 2025 pukul 23.59 WIB.",
    },
    {
      question: "Apa saja persyaratan umum untuk melamar ODP di industri perbankan ini?",
      answer:
        'Persyaratan umum dapat dilihat di: https://odp-recruitment.onegml.com/15/16',
    },
    {
      question: "Apakah ada biaya yang harus dibayar untuk mengikuti rekrutmen ini?",
      answer:
        "Tidak ada biaya apapun yang dipungut dalam seluruh proses seleksi ini. Hati-hati terhadap segala bentuk penipuan yang meminta biaya atau menjanjikan kelulusan.",
    },
    {
      question: "Bagaimana tahapan seleksi ODP 2025 di industri perbankan ini?",
      answer:
        "Tahapan seleksi terdiri dari:\n• Seleksi Administrasi\n• Psikotes Online\n• Tes Kompetensi Teknis\n• Assessment Center\n• Interview HR\n• Final Interview (dengan user)",
    },
    {
      question: "Bagaimana saya mengetahui jika lolos seleksi tahap berikutnya?",
      answer:
        "Pengumuman hasil seleksi akan dikirimkan melalui email resmi: admin.ac@gmlperformance.co.id. Pastikan email yang Anda daftarkan aktif dan dapat diakses secara rutin.",
    },
    {
      question: "Apa yang harus dilakukan jika saya mengalami kendala teknis saat pendaftaran?",
      answer:
        "Untuk kendala teknis yang bersifat mendesak (misal kesulitan login atau upload), Anda bisa mengirimkan kontak ke WhatsApp: 0852-1854-8135 (hanya pada jam kerja: Senin–Jumat pukul 09:00–16:00 WIB).",
    },
    {
      question: "Apakah keputusan hasil seleksi dapat diganggu gugat?",
      answer:
        "Tidak. Keputusan panitia seleksi (ONE GML dan user) bersifat mutlak dan tidak dapat diganggu gugat.",
    },
    {
      question: "Apakah boleh mendaftar lebih dari satu posisi?",
      answer:
        "Melamar untuk posisi lebih dari 1 diperbolehkan.",
    },
    {
      question: "Jika saya lolos, kapan saya akan mulai bergabung dalam program ODP ini?",
      answer:
        "Kandidat yang lolos akan mendapatkan informasi jadwal onboarding secara detail melalui email resmi setelah pengumuman akhir seleksi.",
    },
    {
      question: "Apakah setelah menyelesaikan ODP langsung diangkat sebagai karyawan tetap?",
      answer:
        "Peserta yang berhasil menyelesaikan ODP sesuai standar akan menjalani masa evaluasi akhir sebelum diangkat menjadi karyawan tetap sesuai kebijakan perusahaan.",
    },
    {
      question: "Di mana lokasi penempatan kerja setelah lulus ODP?",
      answer:
        "Seluruh peserta ODP wajib bersedia ditempatkan di seluruh wilayah kerja Kalimantan Tengah. Penempatan akan ditentukan berdasarkan kebutuhan organisasi.",
    },
    {
      question: "Bagaimana cara melaporkan jika ada indikasi kecurangan dalam proses seleksi?",
      answer:
        "Anda dapat melaporkan segala bentuk indikasi kecurangan ke:\n• Email resmi: admin.ac@gmlperformance.co.id\n• WhatsApp resmi: 0852-1854-8135 (khusus laporan mendesak)",
    },
  ];

  const filteredFaqs = faqs.filter((faq) =>
    faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
    faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
  );



  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    axios
      .get(
        `${process.env.REACT_APP_URL}ac/recruitment/participant/company_detail/${id2}`,
        {
          headers: {
            Authorization:
              "Basic " +
              btoa(
                `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`
              ),
          },
        }
      )
      .then(() => {
        setLoading(false);
      })
      .catch(() => setLoading(false));

    return () => window.removeEventListener("resize", handleResize);
  }, [id2]);

  if (loading) {
    return (
      <div className="text-center vh-100 d-flex justify-content-center align-items-center">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <>
      {/* Banner Section */}
      <section className="vh-100">
        <div
          className="position-relative w-100 h-100"
          style={{
            backgroundImage: `url("/banner-gmp.png")`,
            backgroundSize: "cover",
            backgroundPosition: "top center",
          }}
        >
          <div className="d-flex flex-column justify-content-center align-items-center h-100 w-100 bg-dark bg-opacity-50 text-white text-center px-3">
            {/* Logo */}
            <div className="d-flex flex-row gap-3 justify-content-center align-items-center">
            {/* <div
              className="bg-white rounded p-1 mb-2"
              style={{ maxWidth: "220px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)" }}
            >
              <img
                src={logoAC}
                alt="Logo Assessment Center"
                className="img-fluid"
              />
            </div>

             <div
              className="bg-white rounded p-1 mb-2"
              style={{ maxWidth: "220px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)" }}
            >
              <img
                src={logoGMP}
                alt="Logo Assessment Center"
                className="img-fluid"
              />
            </div> */}

            </div>

            {/* Heading Text */}
            <h4 className="fw-bold mb-2">
              Form Aplikasi Rekrutmen Graha Multi Bintang (GMP) 2025
            </h4>
            <p className="mb-4 fs-5">
              Selamat Datang Peserta Calon Kandidat SIMO Manager di Graha Multi Bintang (GMP) 2025
            </p>

            {/* Daftar Button */}
            <button
              className="btn bg-blue text-white px-5 py-2 fs-5"
              onClick={() => {
                document.getElementById("informasi-umum")?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Pelajari lebih lanjut
            </button>


            {/* Warning if mobile */}
            {isMobile && <p className="fw-bold mt-3">Daftar melalui laptop/PC</p>}
          </div>
        </div>
      </section>


      {/* Tabs Section */}
      <section className="container py-5" id="informasi-umum">
        <ul className="nav justify-content-center gap-2 mb-4">
          <li className="nav-item">
            <button
              className={`btn px-4 rounded shadow-sm ${activeTab === "informasi"
                  ? "bg-blue text-white"
                  : "bg-white text-blue"
                }`}
              style={{ border: "none" }}
              onClick={() => setActiveTab("informasi")}
            >
              Qualifications
            </button>
          </li>
          {/* <li className="nav-item">
            <button
              className={`btn px-4 rounded shadow-sm ${activeTab === "faq"
                  ? "bg-blue text-white"
                  : "bg-white text-blue"
                }`}
              style={{ border: "none" }}
              onClick={() => setActiveTab("faq")}
            >
              Frequently Asked Questions (FAQ)
            </button>
          </li> */}
        </ul>


        <div className="text-start">
          {activeTab === "informasi" && (
            <ol className="fs-6">
              <p className="fw-bold fs-5 mb-4">
                    {dataPosition.position}
                  </p>
              {dataPosition?.requirements?.map((item) => (
                      <li className="">{item.name}</li>
                  ))}
              {/* <li>
                Pelamar hanya dapat mengajukan lamaran secara{" "}
                <strong><em>online</em></strong> melalui halaman web{" "}
                <a
                  href="https://odp-recruitment.onegml.com/15/16"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue text-white px-2 py-1 rounded text-decoration-none"
                  style={{ display: "inline-block" }}
                >
                  https://odp-recruitment.onegml.com/15/16
                </a>{" "}
                dengan melengkapi seluruh persyaratan yang dibutuhkan. <strong>Panitia tidak menerima lamaran melalui email atau pos.</strong>
              </li>

              <li>
                Periode registrasi <strong><em>online</em></strong> dimulai pada tanggal <strong>23 Mei 2025</strong> dan akan berakhir pada tanggal <strong>1 Juni 2025 pukul 23.59 WIB. Lamaran yang diterima di luar periode tersebut tidak akan diproses.</strong>
              </li>

              <li>
                <strong>
                  Siapkan dokumen-dokumen penting berikut sebelum mendaftar:
                </strong>
                <ul>
                  <li>KTP</li>
                  <li>Ijazah dan Transkrip Nilai terakhir</li>
                  <li>Bukti screenshoot keabsahan ijazah dari website DIKTI</li>
                  <li>CV terbaru</li>
                  <li>Sertifikat pendukung (jika ada)</li>
                  <li>Pas foto terbaru ukuran 4x6</li>
                </ul>
              </li>

              <li>
                Proses rekrutmen dan seleksi dibagi ke dalam beberapa tahapan yang seluruhnya dilakukan oleh PT. GML Performance Consulting. Tahapan terakhir berupa wawancara akhir akan dilakukan secara langsung oleh user. Pada setiap tahapan seleksi, dilakukan evaluasi untuk menentukan kandidat yang memenuhi kriteria dan akan melanjutkan ke tahapan berikutnya.
              </li>

              <li>
                Setiap peserta yang lolos ke tahap seleksi berikutnya akan diinformasikan melalui email resmi dari <strong>admin.ac@gmlperformance.co.id</strong> dan/atau <strong>melalui nomor WA yang tercantum pada aplikasi pendaftaran.</strong> Pastikan email dan nomor telepon yang Anda cantumkan aktif dan pantau email Anda secara berkala untuk menerima update tahapan seleksi.
              </li>

              <li>
                <strong>
                  Kandidat yang tidak menerima email ataupun WA dari pihak PT. GML berarti tidak lanjut ke proses berikutnya.</strong>
              </li>

              <li>
                PT. GML Performance Consulting dan user memiliki hak penuh untuk menentukan kelulusan kandidat pada setiap tahap seleksi yang dilakukan. <strong> Keputusan penyelenggara bersifat mutlak dan tidak dapat diganggu gugat.
                </strong>
              </li>

              <li>
                <strong>
                  Pastikan seluruh informasi yang Anda berikan adalah benar dan valid.
                </strong> Pelamar yang terbukti memberikan informasi palsu akan didiskualifikasi.
              </li>

              <li>
                Kami <strong> tidak memungut biaya dalam bentuk apapun</strong> selama proses rekrutmen dan seleksi berlangsung. Jika terdapat pihak yang meminta biaya atau menjanjikan kelulusan dalam proses ini, harap segera laporkan melalui:
                <ul>
                  <li><strong>Call Center ONE GML: +62 852-1854-8135</strong></li>
                  <li><strong>Email resmi: admin.ac@gmlperformance.co.id</strong></li>
                </ul>
              </li>

              <li>
                Nomor WhatsApp hanya untuk kendala terkait teknis pendaftaran atau laporan kecurangan.<strong> Pertanyaan umum tidak akan dilayani melalui WA, pertanyaan umum mengenai rekrutmen dapat dilihat pada kolom FAQ.</strong>
              </li> */}
            </ol>
          )}


          {activeTab === "faq" && (
            <>
              <input
                type="text"
                className="form-control mb-4"
                placeholder="Cari pertanyaan..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <div className="accordion" id="faqAccordion">
                {filteredFaqs.length > 0 ? (
                  filteredFaqs.map((faq, index) => (
                    <div className="accordion-item" key={index}>
                      <h2 className="accordion-header" id={`heading${index}`}>
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${index}`}
                          aria-expanded="false"
                          aria-controls={`collapse${index}`}
                        >
                          {faq.question}
                        </button>
                      </h2>
                      <div
                        id={`collapse${index}`}
                        className="accordion-collapse collapse"
                        aria-labelledby={`heading${index}`}
                        data-bs-parent="#faqAccordion"
                      >
                        <div className="accordion-body fw-bold">
                          {faq.answer.split("\n").map((line, i) => (
                            <p key={i} className="mb-1">{line}</p>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-muted">Tidak ditemukan hasil pencarian.</p>
                )}
              </div>

              {/* WhatsApp Helpdesk Button below the accordion */}
              <div className="text-end mt-4">
                <a
                  href="https://wa.me/6285218548135"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn d-inline-flex align-items-center px-4 py-2"
                  style={{
                    backgroundColor: "white",
                    color: "#25D366", // WhatsApp green
                    borderRadius: "0.375rem",
                    fontWeight: "600",
                    textDecoration: "none",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  }}
                >
                  <i className="fa-brands fa-whatsapp me-2" aria-hidden="true" style={{ fontSize: "20px" }}></i>
                  Helpdesk
                </a>
              </div>

            </>
          )}

        </div>
      </section>

      <section className="container pb-3">
        <div className="text-center">
          <button
            className="btn bg-blue text-white px-5 py-2 fs-5 w-100"
            onClick={() => navigate(`/form/${id}/${id2}`)}
            disabled={isMobile}
          >
            Daftar Sekarang
          </button>

          {isMobile && (
            <p className="fw-bold mt-3">Daftar melalui laptop/PC</p>
          )}
        </div>
      </section>

      <footer className="bg-blue text-white text-center py-3 mt-5">
        Copyright © Assessment Center Solutions 2025. <br />
        All rights reserved. v 1.0.0
      </footer>

    </>
  );
};

export default WelcomePage;
